export default {
    index: "Willkommen",
    users: "Nutzer",
    organisations: "Organisationen",
}
